import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import TextFormat from '../common/TextFormat.jsx';

const DisclaimerBlock = styled.div`
    border: 0.15rem solid #aaaaaa;
    border-radius: 0.25rem;
    padding: 1.25rem 1.75rem 1rem;
    background-color: white;
    text-align: center;
`;

const DisclaimerText1 = styled.div`
    font-size: 1.25rem;
    font-style: italic;
    color: #888888;
    margin-bottom: 1rem;
`;

const DisclaimerText2 = styled.div`
    font-size: 0.9rem;
    font-style: italic;
    color: #888888;
    margin-bottom: 0.5rem;
`;

export class SidebarDisclaimer extends Component {

    static propTypes = {
        items: PropTypes.object.isRequired,
    }

    render() {
        const {items} = this.props;

        const disclaimer_keys = Object.keys(items);
        let disclaimers_unsorted = [];
        disclaimer_keys.forEach(key => disclaimers_unsorted.push({
            index: items[key].index,
            text: items[key].value
        }));
        const disclaimers = disclaimers_unsorted
            .sort((a, b) => a.index - b.index)
            .map(a => a.text);
        const disclaimer1 = disclaimers.slice(0, 1).map((d, i) =>
            <DisclaimerText1 key={i}><TextFormat text={d} is_first={true} of_many={false}/></DisclaimerText1>
        );
        const disclaimer2 = disclaimers.slice(1, 3).map((d, i) =>
            <DisclaimerText2 key={i}><TextFormat text={d} is_first={true} of_many={false}/></DisclaimerText2>)

        return <DisclaimerBlock>
            {disclaimer1}
            {disclaimer2}
        </DisclaimerBlock>
    }
}

export default SidebarDisclaimer;